












import { Vue, Component } from "vue-property-decorator";
import ContractForm from "@/components/contract/ContractForm.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";

@Component({
  components: { CPage, ContractForm }
})
export default class ContractNew extends Vue {
  get breadcrumbs() {
    return [
      {
        to: { name: "contracts" },
        label: this.$tc(this.$translate.Contracts)
      },
      {
        label: this.$tc(this.$translate.Add)
      }
    ];
  }
}
